import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

import { MachineCategory } from '../../../../core/models/entities/machine-category.type';

@Component({
  selector: 'modal-create-machine-category',
  templateUrl: './modal-create-machine-category.component.html',
  styleUrls: ['./modal-create-machine-category.component.scss']
})
export class ModalCreateMachineCategoryComponent {
  machineCategory = new MachineCategory();

  constructor(
    private dialogRef: MatDialogRef<ModalCreateMachineCategoryComponent>
  ) {}

  save(): void {
    this.dialogRef.close(this.machineCategory);
  }
}
